module.exports = __webpack_public_path__ + "static/img/Innovation-hub-15.222371a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/Innovation-hub-15.jpg
// module id = n/0Z
// module chunks = 0